// Kamojo AJAX add to cart: posts the wrapped form to /cart/add.js and refreshes Dawn's cart drawer.
if (!customElements.get('kj-add-to-cart')) {
  class KjAddToCart extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.button = this.querySelector('[data-kj-atc-button]');
      this.label = this.querySelector('[data-kj-atc-label]');
      this.status = this.querySelector('[data-kj-atc-status]');
      this.error = this.querySelector('[data-kj-atc-error]');
      if (!this.form || !this.button) return;
      if (this.idleText === undefined) this.idleText = this.label ? this.label.textContent.trim() : '';
      this.onSubmit = this.onSubmit || ((event) => this.submit(event));
      this.form.addEventListener('submit', this.onSubmit);
    }

    disconnectedCallback() {
      if (this.form) this.form.removeEventListener('submit', this.onSubmit);
      clearTimeout(this.resetTimer);
    }

    lines() {
      const data = new FormData(this.form);
      if (data.get('id')) return [{ id: Number(data.get('id')), quantity: Number(data.get('quantity')) || 1 }];
      const lines = [];
      data.forEach((value, key) => {
        const match = key.match(/^items\[(\d+)\]\[(id|quantity)\]$/);
        if (!match) return;
        const line = (lines[match[1]] = lines[match[1]] || { quantity: 1 });
        line[match[2]] = Number(value);
      });
      return lines.filter((line) => line && line.id);
    }

    announce(message) {
      if (!this.status) return;
      this.status.textContent = '';
      window.setTimeout(() => (this.status.textContent = message), 60);
    }

    setState(state, message = '') {
      this.dataset.state = state;
      this.button.setAttribute('aria-busy', String(state === 'loading'));
      if (this.label) this.label.textContent = state === 'success' && this.dataset.addedLabel ? this.dataset.addedLabel : this.idleText;
      if (this.error) {
        this.error.hidden = state !== 'error';
        this.error.textContent = state === 'error' ? message : '';
      }
      if (message) this.announce(message);
    }

    async submit(event) {
      event.preventDefault();
      if (this.dataset.state === 'loading' || this.button.disabled) return;
      const items = this.lines();
      if (!items.length) return;

      // Same integration as Dawn's product form: let the cart drawer (if enabled) re-render itself from this response.
      const cartDrawer = document.querySelector('cart-drawer');
      const header = document.querySelector('kj-header');
      const sections = [];
      if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
        cartDrawer.getSectionsToRender().forEach((section) => sections.push(section.id));
      }
      if (header && header.dataset.sectionId) sections.push(header.dataset.sectionId);

      clearTimeout(this.resetTimer);
      this.setState('loading', this.dataset.loadingText);
      try {
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items, sections: sections.slice(0, 5), sections_url: window.location.pathname }),
        });
        const data = await response.json();
        if (!response.ok || data.status) throw new Error(data.description || data.message || this.dataset.errorText);
        this.setState('success', this.dataset.successText);
        this.notify(data, cartDrawer);
        this.resetTimer = setTimeout(() => this.setState('idle'), 2500);
      } catch (error) {
        this.setState('error', (error && error.message) || this.dataset.errorText);
        this.resetTimer = setTimeout(() => this.setState('idle'), 6000);
      }
    }

    notify(data, cartDrawer) {
      document.dispatchEvent(
        new CustomEvent('kj:cart:updated', { detail: { items: data.items || [], sections: data.sections || {} } })
      );
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'kj-add-to-cart', cartData: data });
      }
      if (cartDrawer && typeof cartDrawer.renderContents === 'function' && data.sections) {
        try {
          cartDrawer.classList.remove('is-empty');
          if (typeof cartDrawer.setActiveElement === 'function') cartDrawer.setActiveElement(this.button);
          cartDrawer.renderContents(data);
        } catch (error) {
          /* The drawer couldn't re-render; the header count is already updated. */
        }
      }
    }
  }
  customElements.define('kj-add-to-cart', KjAddToCart);
}
